// Copyright ©️ 2025 eVolve MEP, LLC

export type TabOption = 'Messages' | 'Activity' | 'Archived';

/**
 * Used to track which notifications are high priority
 * and should not be closed on page nav.
 */
export const hiPriNotificationPrefix = 'hi-pri-message' as const;
